<template>
  <div id="contenedor-programasinversion-default">
    <v-container
      fluid>
      <v-card
        class="mb-4"
        flat>
        <v-card-text>
          <titulo-tool-bar></titulo-tool-bar>
          <tool-bar
            class="mb-4"
            :filtros="filtros"
            v-on:nuevoProgramaInversion="registrarNuevoProgramaInversion"
            >
          </tool-bar>
        </v-card-text>
      </v-card>
      <v-card
        flat>
        <v-card-text>
          <listado :listadoProgramasInversion="getProgramasInversiones"></listado>
        </v-card-text>
      </v-card>
    </v-container>
    <!-- CUADRO DE DIALOGO AGREGAR -->
    <v-dialog
      v-model="mostrarVentanaRegistrarNuevoProgramaInversion"
      :width="!$vuetify.breakpoint.mobile ? '50%' : '90%'">
      <registrar-nuevo-programa-inversion
        v-if="mostrarVentanaRegistrarNuevoProgramaInversion"
        v-on:cerrar="cerrarRegistrarNuevoProgramaInversion">
      </registrar-nuevo-programa-inversion>
    </v-dialog>
    <!-- CUADRO DE DIALOGO EDITAR -->
    <v-dialog
    v-if="esteProgramaInversion"
      v-model="mostrarVentanaEditarProgramaInversion"
      :width="!$vuetify.breakpoint.mobile ? '50%' : '90%'">
      <editar-programa-inversion
      :programaInversionEditar="esteProgramaInversion"
        v-on:cerrar="cerrarEditarProgramaInversion">
      </editar-programa-inversion>
    </v-dialog>
    <!-- CUADRO DE DIALOGO ELIMINAR -->
    <v-dialog
    v-if="esteProgramaInversion"
      v-model="mostrarVentanaEliminarProgramaInversion"
      :width="!$vuetify.breakpoint.mobile ? '450' : '90%'">
      <eliminar-programa-inversion
      :programaInversionEliminar="esteProgramaInversion"
        v-on:cerrar="cerrarEliminarProgramaInversion">
      </eliminar-programa-inversion>
    </v-dialog>
  </div>
</template>

<script>
import PROGRAMAS_INVERSIONES from '@/graphql/querys/administracion/catalogos/programasinversiones/programasInversiones.gql';
import TituloToolBar from './TituloToolBar.vue';
import RegistrarNuevoProgramaInversion from '@/components/administracion/configuracion/catalogos/programasinversion/Nuevo.vue';
import EditarProgramaInversion from '@/components/administracion/configuracion/catalogos/programasinversion/Editar.vue';
import EliminarProgramaInversion from '@/components/administracion/configuracion/catalogos/programasinversion/Eliminar.vue';
import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ProgramasInversionDefault',
  components: {
    TituloToolBar,
    RegistrarNuevoProgramaInversion,
    EditarProgramaInversion,
    EliminarProgramaInversion,
    ToolBar,
    Listado,
  },
  data() {
    return {
      mostrarVentanaRegistrarNuevoProgramaInversion: false,
      mostrarVentanaEditarProgramaInversion: false,
      mostrarVentanaEliminarProgramaInversion: false,
      esteProgramaInversion: null,
      filtros: {
        buscarTexto: '',
      },
    };
  },
  apollo: {
    programasInversiones: {
      query: PROGRAMAS_INVERSIONES,
    },
  },
  mounted() {
    eventBus.$on('editar-programa-inversion', (programaInversion) => {
      this.esteProgramaInversion = programaInversion;
      this.mostrarVentanaEditarProgramaInversion = true;
    });
    eventBus.$on('eliminar-programa-inversion', (programaInversion) => {
      this.esteProgramaInversion = programaInversion;
      this.mostrarVentanaEliminarProgramaInversion = true;
    });
  },
  methods: {
    registrarNuevoProgramaInversion() {
      this.mostrarVentanaRegistrarNuevoProgramaInversion = true;
    },
    cerrarRegistrarNuevoProgramaInversion() {
      this.mostrarVentanaRegistrarNuevoProgramaInversion = false;
    },
    cerrarEditarProgramaInversion() {
      this.mostrarVentanaEditarProgramaInversion = false;
      this.esteProgramaInversion = null;
    },
    cerrarEliminarProgramaInversion() {
      this.mostrarVentanaEliminarProgramaInversion = false;
      this.esteProgramaInversion = null;
    },
  },
  computed: {
    getProgramasInversiones() {
      if (!this.programasInversiones) return [];
      return this.programasInversiones
      // Filtrar por Texto de Busqueda
        .filter((programaInversion) => {
          if (!this.filtros.buscarTexto) return programaInversion;
          const expt = new RegExp(this.filtros.buscarTexto, 'gi');
          const clave = this.$normalizacionTexto(programaInversion.clave);
          const nombre = this.$normalizacionTexto(programaInversion.nombre);
          return (
            expt.test(clave)
            || expt.test(nombre)
            || expt.test(programaInversion.clave)
            || expt.test(programaInversion.nombre)
            || expt.test(programaInversion.ejercicio)
          );
        });
    },
  },
};
</script>

<style lang="scss">

</style>
